/* eslint-disable no-console */
import { takeLatest, put, select } from 'redux-saga/effects';
import moment from 'moment';
import { setNotification } from 'utils';
import {
    LOAD_ROLLS_IN,
    CHANGE_ROLL_IN_SRTATUS,
} from '../types/rollInTypes';
import {
    getRollsInApi,
    changeRollInStatusApi,
} from '../api/rollInApi';
import {
    loadRollsInRes,
    loadRollsInErr,
    changeRollInStatusRes,
} from '../actions/rollInActions';

const getLayout = state => state.layout;
const getRollIn = state => state.rollIn;

// L O A D   R O L L S   I N
function* loadRollsInSaga() {
    const { sort, offset, limit, filters } = yield select(getRollIn);

    try {
        const params = {
            limit,
            offset,
            joins: JSON.stringify(['forms']),
        };

        const sendFilters = {};

        if (filters.rollerBarcode !== '') {
            sendFilters.roll_barcode = {
                operator: 'typing',
                value: filters.rollerBarcode,
            };
        }

        if (filters.quality !== '') {
            sendFilters.quality = {
                operator: 'typing',
                value: filters.quality,
            };
        }

        if (filters.width !== '') {
            sendFilters.width = parseInt(filters.width, 10);
        }

        if (filters.height !== '') {
            sendFilters.height = parseInt(filters.height, 10);
        }

        if (filters.creationDate.length > 0) {
            const customDate = [
                moment.utc(filters.creationDate[0]).format('YYYY-MM-DD 00:00:00'),
                moment.utc(filters.creationDate[1]).format('YYYY-MM-DD 23:59:59'),
            ];
            sendFilters.created_at = { between: customDate };
        }

        if (filters.status !== undefined) {
            sendFilters.state = filters.status;
        }

        params.filter = JSON.stringify(sendFilters);

        if (sort !== null) {
            const sortInt = sort.type === 'asc' ? 1 : -1;

            if (sort.key === 'created_at') {
                params.sort_by = JSON.stringify({ created_at: sortInt });
            } else if (sort.key === 'roll_number') {
                params.sort_by = JSON.stringify({ roll_number: sortInt });
            } else if (sort.key === 'quality') {
                params.sort_by = JSON.stringify({ quality: sortInt });
            }
        }

        const result = yield getRollsInApi(params);

        if (result.status === 200) {
            yield put(loadRollsInRes(result.data));
        }
    } catch (e) {
        console.log(e);
        yield put(loadRollsInErr());
    }
}

export function* loadRollsInWatcher() {
    yield takeLatest(LOAD_ROLLS_IN, loadRollsInSaga);
}
// L O A D   R O L L S   I N

// C H A N G E   R O L L   I N   S T A T U S
function* changeRollInStatusSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const params = {
            roll_in_id: action.id,
            status: 'USED',
        };

        const result = yield changeRollInStatusApi(params);
        if (result.status === 202) {
            yield put(changeRollInStatusRes(result.data));
            setNotification('success', locale, 'global.success', 'rollIn.changeStatusSuccess');
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            // setNotification('error', locale, 'global.error', 'rollIn.changeStatusError');
        }
        yield put({ type: LOAD_ROLLS_IN });
    } catch (e) {
        console.log(e);
    }
}

export function* changeRollInStatusWatcher() {
    yield takeLatest(CHANGE_ROLL_IN_SRTATUS, changeRollInStatusSaga);
}
// C H A N G E   R O L L   I N   S T A T U S
